import { render, staticRenderFns } from "./addTalent.vue?vue&type=template&id=ce3f55ae&scoped=true"
import script from "./addTalent.vue?vue&type=script&lang=js"
export * from "./addTalent.vue?vue&type=script&lang=js"
import style0 from "./addTalent.vue?vue&type=style&index=0&id=ce3f55ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3f55ae",
  null
  
)

export default component.exports